import {PurchasePage} from '../purchasePage';
import {Infobox} from '../../../htmlHelpers/infobox';
import {ApiError} from '../../../services/api';
import {
  clearHtmlContent,
  getElement,
  setHtmlContent,
} from '../../../services/html';
import {HtmlHelper} from '../../../services/htmlHelper';
import {PURCHASE_PAGE_DONE} from '../../../config/paths';
import {HTML_PURCHASE_CHECKOUT_VERIFY_IDS} from '../../../const/html';
import {LoadingVisController} from '../../../htmlHelpers/loadingVisController';

export class CheckoutVerifyPage extends PurchasePage {
  private errorNode: HTMLElement | null = null;
  private visController: LoadingVisController | null = null;

  public render(): void {
    void this.verifySetupIntent(); // dont await
  }

  private clearError(): void {
    clearHtmlContent(this.errorNode);
  }

  private setError(err: ApiError): void {
    let msg = err.message;

    const dropinErrMsg = this.dropinErrorToMsg(err);
    if (dropinErrMsg) msg = dropinErrMsg;

    setHtmlContent(this.errorNode, Infobox(msg, true, err.executionId));
    this.visController?.finishLoading(false);
  }

  private setErrorMessage(msg: string): void {
    setHtmlContent(this.errorNode, Infobox(msg, true));
    this.visController?.finishLoading(false);
  }

  private async verifySetupIntent(): Promise<void> {
    this.errorNode = getElement(
      `#${HTML_PURCHASE_CHECKOUT_VERIFY_IDS.errorContainer}`,
    );
    this.visController = new LoadingVisController(
      getElement('.sc-loading-visible'),
      getElement('.sc-loading-hidden'),
      getElement('.sc-loading-error'),
    );

    this.visController.startLoading();

    const qp = HtmlHelper.instance.getUrlQueryParams();

    if (qp.provider === 'adyen') {
      if (qp.redirectResult) {
        try {
          const resp = await this.purchaseService.adyenProvideDetails(
            {
              details: {
                redirectResult: qp.redirectResult,
              },
            },
            qp.variant,
            qp.cid,
          );

          if (resp.complete) {
            this.showPaymentSuccess();
          } else {
            // should never be the case:
            // a redirect payment should always be succeeded after redirect back or refused.
            // But no further action should be required.
            console.error('redirect payment not completed!');
            this.setErrorMessage('Payment not successful.');
          }
        } catch (err) {
          if (err instanceof Error) {
            console.log('verify failed!', {...err});
            if (err instanceof ApiError) {
              this.setError(err);
            } else {
              this.setErrorMessage(err.message);
            }
          }
        }
      } else {
        console.error('No redirectResult in query params');
        this.setErrorMessage(
          'There was an error verifying your payment. Please try again later.',
        );
      }
    }
  }

  private showPaymentSuccess() {
    console.log('payment succeeded!');
    window.location.href = PURCHASE_PAGE_DONE;
  }
}
